import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide',
  {
    variants: {
      variant: {
        default: 'bg-primary-500 text-white',
        verified: 'bg-success-50 text-success-600 ring-1 ring-success-500/20',
        premium: 'bg-primary-50 text-primary-600 ring-1 ring-primary-500/30',
        hot: 'bg-danger-50 text-danger-500 ring-1 ring-danger-500/20',
        new: 'bg-secondary-100 text-secondary-600',
        sale: 'bg-[#fff0e8] text-accent-600 ring-1 ring-accent-500/30',
        rent: 'bg-[#eef6ff] text-secondary-500 ring-1 ring-secondary-500/30',
        commercial: 'bg-neutral-100 text-neutral-700 ring-1 ring-neutral-500/25',
        outline: 'border border-neutral-200 bg-white text-neutral-600',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}
